import { PROVINCE, getProvincePrincipalCity } from '@ratehub/base-ui';
import { RATE_TYPES } from '@ratehub/documents/mtg-journey-document/stable';

import SCENARIO_TYPES from './scenarioTypes';
import { MORTGAGE_TERMS } from './mortgageTerms';


export const DEFAULT_MORTGAGE_PROVINCE = PROVINCE.ONTARIO;
export const DEFAULT_MORTGAGE_CITY = getProvincePrincipalCity(DEFAULT_MORTGAGE_PROVINCE);
export const DEFAULT_MORTGAGE_TYPE = RATE_TYPES.FIXED;
export const DEFAULT_MORTGAGE_TERM = MORTGAGE_TERMS[4];

export const DEFAULT_ALL_PURCHASE_PARAMS = {
    city: DEFAULT_MORTGAGE_CITY,
    homePrice: 400000,
    downPaymentPercent: 0.05,
    amortization: 25,
    isOwnerOccupied: true,
    isCashBack: false,
    isOpen: false,
    type: DEFAULT_MORTGAGE_TYPE,
    term: DEFAULT_MORTGAGE_TERM,
};

export const DEFAULT_BEST_PURCHASE_PARAMS = {
    city: DEFAULT_MORTGAGE_CITY,
    amortization: 25,
    downPaymentPercent: 0.05,
    homePrice: 400000,
    isOwnerOccupied: true,
    isCashBack: false,
    isOpen: false,
    type: [ DEFAULT_MORTGAGE_TYPE ],
    term: [ DEFAULT_MORTGAGE_TERM ],
};

export const DEFAULT_ALL_HELOC_PARAMS = {
    city: DEFAULT_MORTGAGE_CITY,
};

export const DEFAULT_BEST_HELOC_PARAMS = {
    city: DEFAULT_MORTGAGE_CITY,
};

export const DEFAULT_ALL_REFINANCE_PARAMS = {
    city: DEFAULT_MORTGAGE_CITY,
    amortization: 25,
    isOwnerOccupied: true,
    isCashBack: false,
    isOpen: false,
    type: DEFAULT_MORTGAGE_TYPE,
    term: DEFAULT_MORTGAGE_TERM,
};

export const DEFAULT_BEST_REFINANCE_PARAMS = {
    city: DEFAULT_MORTGAGE_CITY,
    amortization: 25,
    isOwnerOccupied: true,
    isCashBack: false,
    isOpen: false,
    type: DEFAULT_MORTGAGE_TYPE,
    term: DEFAULT_MORTGAGE_TERM,
};

export const DEFAULT_ALL_RENEW_PARAMS = {
    city: DEFAULT_MORTGAGE_CITY,
    isInsured: 1,
    isOwnerOccupied: true,
    isCashBack: false,
    isOpen: false,
    type: DEFAULT_MORTGAGE_TYPE,
    term: DEFAULT_MORTGAGE_TERM,
};

export const DEFAULT_BEST_RENEW_PARAMS = {
    city: DEFAULT_MORTGAGE_CITY,
    isInsured: 1,
    isOwnerOccupied: true,
    isCashBack: false,
    isOpen: false,
    type: DEFAULT_MORTGAGE_TYPE,
    term: DEFAULT_MORTGAGE_TERM,
};

export const ALL_MORTGAGE_SCENARIO_DEFAULT_PARAMS = {
    [SCENARIO_TYPES.PURCHASE]: DEFAULT_ALL_PURCHASE_PARAMS,
    [SCENARIO_TYPES.RENEWAL]: DEFAULT_ALL_RENEW_PARAMS,
    [SCENARIO_TYPES.REFINANCE]: DEFAULT_ALL_REFINANCE_PARAMS,
    [SCENARIO_TYPES.HELOC]: DEFAULT_ALL_HELOC_PARAMS,
};

export const BEST_MORTGAGE_SCENARIO_DEFAULT_PARAMS = {
    [SCENARIO_TYPES.PURCHASE]: DEFAULT_BEST_PURCHASE_PARAMS,
    [SCENARIO_TYPES.RENEWAL]: DEFAULT_BEST_RENEW_PARAMS,
    [SCENARIO_TYPES.REFINANCE]: DEFAULT_BEST_REFINANCE_PARAMS,
    [SCENARIO_TYPES.HELOC]: DEFAULT_BEST_HELOC_PARAMS,
};
